import { getPricingVehicleByIdRequest } from "../../data/pricingVehicleApi";

function getPayloadData(response) {
  if (response?.data && !Array.isArray(response.data)) {
    return response.data;
  }

  if (response?.data?.data && !Array.isArray(response.data.data)) {
    return response.data.data;
  }

  return null;
}

export async function getPricingVehicleByIdUseCase(id) {
  const pricingVehicle = getPayloadData(await getPricingVehicleByIdRequest(id));

  if (!pricingVehicle) {
    throw new Error("No se pudo obtener la configuracion del vehiculo.");
  }

  return pricingVehicle;
}
